import {
  useEffect,
  useLayoutEffect,
  useState,
} from "react";

const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

export const useIsMobile = (mobileWidth: number) => {
  const [ matches, setMatches ] = useState(false);

  useIsomorphicLayoutEffect(() => {
    const matchMedia = window.matchMedia(`(max-width: ${mobileWidth}px)`);

    const handleChange = () => setMatches(matchMedia.matches);
    handleChange();

    matchMedia.addEventListener("change", handleChange);
    return () => matchMedia.removeEventListener("change", handleChange);
  }, []);

  return matches;
};
